module.exports = __webpack_public_path__ + "img/11.52ff2b49.jpg";